import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { SquareSplitHorizontal, SquareSplitVertical } from "@phosphor-icons/react";

// Shown only when exactly 2 images are selected for merging, since that's
// the one case with a genuinely ambiguous "obvious" layout. 3-4 images fall
// back to an automatic 2-column grid without asking (see handleMergeCaptures).
export function MergeLayoutDialog({ open, onOpenChange, onChoose }) {
  const { t } = useTranslation();

  const choose = (layout) => {
    onOpenChange(false);
    onChoose(layout);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm rounded-none" data-testid="merge-layout-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">{t("mergeDialog.title")}</DialogTitle>
          <DialogDescription>{t("mergeDialog.description")}</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <button
            type="button"
            data-testid="merge-layout-vertical-button"
            onClick={() => choose("vertical")}
            className="flex flex-col items-center gap-2 border border-border p-5 hover:border-primary hover:bg-secondary transition-colors"
          >
            <SquareSplitHorizontal size={32} className="text-primary" />
            <span className="text-sm font-semibold">{t("mergeDialog.vertical")}</span>
          </button>
          <button
            type="button"
            data-testid="merge-layout-horizontal-button"
            onClick={() => choose("horizontal")}
            className="flex flex-col items-center gap-2 border border-border p-5 hover:border-primary hover:bg-secondary transition-colors"
          >
            <SquareSplitVertical size={32} className="text-primary" />
            <span className="text-sm font-semibold">{t("mergeDialog.horizontal")}</span>
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
